import { Command, buildChangeIncentiveAction } from '@nextforce/api'
import { EditCriticalShiftBonusScreenProps } from 'home/stack/types'
import { t } from 'app/i18l'
import React, { useCallback, useLayoutEffect, useState } from 'react'
import { showHeaderTitle } from 'shared/header/header_title'
import { usePerformShiftAction } from 'shifts/queries/perform_action'
import { useShiftActions } from 'shifts/shift_actions_context'
import EditCriticalShiftBonusView from './view'

export function EditCriticalShiftBonusScreen({
  navigation,
  route,
}: EditCriticalShiftBonusScreenProps) {
  const { actionCommand, setActionCommand } = useShiftActions()
  const shiftMutation = usePerformShiftAction()

  const { shiftData } = route.params

  const [newBonusAmount, setNewBonusAmount] = useState(
    shiftData.shift?.bonus?.amount ?? 0
  )
  const [error, setError] = useState(undefined)
  useLayoutEffect(() => {
    showHeaderTitle(navigation, t('changeAmount'))
  })

  const onButtonPress = useCallback(
    async (command: Command) => {
      if (command.type === 'action') {
        try {
          await shiftMutation.mutateAsync(command.action)
          setActionCommand(undefined)
          navigation.goBack()
        } catch (err: any) {
          setError(err)
        }
      }
    },
    [navigation, setActionCommand, shiftMutation]
  )
  const editCriticalShiftBonusCommands: Command[] = [
    {
      groupId: 1,
      action: buildChangeIncentiveAction(
        actionCommand?.action!,
        shiftData.shift?.bonus?.amount,
        newBonusAmount
      ),
      type: 'action',
      title: t('confirmChangedAmount'),
      style: 'primary',
    },
  ]
  return (
    <EditCriticalShiftBonusView
      newBonusAmount={newBonusAmount}
      setNewBonusAmount={setNewBonusAmount}
      commands={editCriticalShiftBonusCommands}
      onCommandButtonPress={onButtonPress}
      shiftData={shiftData}
      error={error}
    />
  )
}
